import { useState } from 'react';
import styled, { css } from 'styled-components';
import { HGrid, Text, Checkbox as TombacCheckbox, VGrid, tombac } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Checkbox = styled(TombacCheckbox).withConfig({
  displayName: "ProductCheckbox__Checkbox"
})(["&&& > [class|='Checkbox__StyledCheckbox']{background-color:transparent;}"]);
const ContainingLabel = styled.label.withConfig({
  displayName: "ProductCheckbox__ContainingLabel"
})(["border:", " solid;border-radius:20px;background:", ";display:grid;gap:", ";grid-auto-flow:row;outline:", " solid ", ";outline-width:", ";padding:", ";transition:0.1s ease-out;transition-property:background-color,border-color,outline-width;", ""], tombac.unit(1), tombac.color('neutral', 100), tombac.space(1), tombac.space(0.5), tombac.color('neutral', 300), _ref => {
  let {
    focused
  } = _ref;
  return focused ? tombac.space(0.5) : 0;
}, tombac.space(2, 2, 2), _ref2 => {
  let {
    checked
  } = _ref2;
  return checked ? css(["background-color:", ";border-color:", ";"], tombac.color('accent', 100), tombac.color('accent', 600)) : css(["border-color:", ";"], tombac.color('neutral', 400));
});
const Description = styled(Text).withConfig({
  displayName: "ProductCheckbox__Description"
})(["color:", ";"], _ref3 => {
  let {
    checked
  } = _ref3;
  return checked ? tombac.color('accent', 500) : undefined;
});
const Limits = styled.div.withConfig({
  displayName: "ProductCheckbox__Limits"
})(["", ""], tombac.text({
  color: tombac.color('accent', 400),
  fontSize: 12,
  fontWeight: 500
}));
const Name = styled.span.withConfig({
  displayName: "ProductCheckbox__Name"
})(["", ""], tombac.altText({
  fontSize: 16,
  fontWeight: 700
}));
const Tagline = styled.div.withConfig({
  displayName: "ProductCheckbox__Tagline"
})(["", ";text-transform:uppercase;"], tombac.text({
  color: tombac.color('accent', 500),
  fontSize: 12,
  fontWeight: 700
}));
const ProductCheckbox = _ref4 => {
  let {
    checked,
    description,
    limits,
    logo: Logo,
    name,
    onBlur,
    onChange,
    tagline
  } = _ref4;
  const [focused, setFocused] = useState(false);
  const handleBlur = event => {
    setFocused(false);
    if (onBlur) onBlur(event);
  };
  const handleFocus = () => {
    setFocused(true);
  };
  return /*#__PURE__*/_jsxs(ContainingLabel, {
    checked: checked,
    focused: focused,
    "data-sentry-element": "ContainingLabel",
    "data-sentry-component": "ProductCheckbox",
    "data-sentry-source-file": "ProductCheckbox.tsx",
    children: [/*#__PURE__*/_jsxs(HGrid, {
      gridTemplateColumns: "max-content 1fr min-content",
      "data-sentry-element": "HGrid",
      "data-sentry-source-file": "ProductCheckbox.tsx",
      "data-sentry-element": "HGrid",
      children: [/*#__PURE__*/_jsx(Logo, {
        height: "40",
        width: "40",
        "data-sentry-element": "Logo",
        "data-sentry-source-file": "ProductCheckbox.tsx",
        "data-sentry-element": "Logo"
      }), /*#__PURE__*/_jsxs(VGrid, {
        gap: 0.5,
        "data-sentry-element": "VGrid",
        "data-sentry-source-file": "ProductCheckbox.tsx",
        "data-sentry-element": "VGrid",
        children: [/*#__PURE__*/_jsx(Tagline, {
          "data-sentry-element": "Tagline",
          "data-sentry-source-file": "ProductCheckbox.tsx",
          "data-sentry-element": "Tagline",
          children: tagline
        }), /*#__PURE__*/_jsx(Name, {
          "data-sentry-element": "Name",
          "data-sentry-source-file": "ProductCheckbox.tsx",
          "data-sentry-element": "Name",
          children: name
        })]
      }), /*#__PURE__*/_jsx(Checkbox, {
        checked: checked,
        label: false,
        onBlur: handleBlur,
        onChange: onChange,
        onFocus: handleFocus,
        "data-sentry-element": "Checkbox",
        "data-sentry-source-file": "ProductCheckbox.tsx",
        "data-sentry-element": "Checkbox"
      })]
    }), /*#__PURE__*/_jsx(Description, {
      checked: checked,
      size: "s",
      variant: "secondary",
      "data-sentry-element": "Description",
      "data-sentry-source-file": "ProductCheckbox.tsx",
      "data-sentry-element": "Description",
      children: description
    }), /*#__PURE__*/_jsx(Limits, {
      "data-sentry-element": "Limits",
      "data-sentry-source-file": "ProductCheckbox.tsx",
      "data-sentry-element": "Limits",
      children: limits.join(' | ')
    })]
  });
};
export default ProductCheckbox;